export default function  Loader() {
    return (
        <div style={{width: '100%', height: '80vh' , position: 'absolute' , left: 0, top: 0, bottom: 0}} className="flex justify-center items-center">
            <span className="bg-gray-900 text-white rounded-sm px-4 py-2">Loading ...</span>
        </div>
    )
}